module.exports = __webpack_public_path__ + "static/media/IDpay.b6428f9d.svg";